import ReactQuill, {Quill} from "react-quill";
import "./blogView.css"
import RecentBlog from "./components/recent-blog";
import 'react-quill/dist/quill.snow.css';
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import axiosInstance from "../../../API/Axios/AxiosConfig";
import URLS from "../../../API/Axios/URLS";
import {getUri} from "../../../utils/utils";
import BlogPostAnimation from "./components/blog-post-animation";

const Parchment = Quill.import("parchment");
const Attribute = Parchment.Attributor.Attribute;
const IdAttribute = new Attribute("id", "id", {
    scope: Parchment.Scope.ALL, // Allow `id` for all scopes (block, inline, etc.)
});
Quill.register(IdAttribute, true);

const addIdsToHeadings = (content) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    let headingIndex = 0;
    Array.from(doc.querySelectorAll("h1, h2, h3")).forEach((heading) => {
        heading.id = `heading-${headingIndex}`;
        headingIndex++;
    });

    return doc.body.innerHTML; // Return the modified HTML content
};
const TOC = ({content}) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    // Collect headings (h1, h2, h3)
    const headings = Array.from(doc.querySelectorAll("h1, h2, h3")).map((heading, index) => ({
        text: heading.textContent,
        id: heading.id,
        level: heading.tagName.toLowerCase(),
    }));
    console.log(headings)
    return (
        <div className="bg-gray-100 p-4 rounded shadow-md">
            <h2 className="text-lg font-semibold border-b pb-2 mb-4">Table of Contents</h2>
            <ul className="space-y-2 list-disc">
                {headings.map((heading) => (
                    <li
                        key={heading.id}
                        onClick={() => {
                            const element = document.getElementById(heading.id);
                            if (element) {
                                console.log(element)
                                element.scrollIntoView({behavior: "smooth"});
                            }
                        }}
                        className={`${
                            heading.level === "h2"
                                ? "ml-4"
                                : heading.level === "h3"
                                    ? "ml-8"
                                    : "ml-0"
                        } text-gray-700 hover:text-blue-500 cursor-pointer`}
                    >
                        {heading.text}
                    </li>
                ))}
            </ul>
        </div>
    );
};


export default function BlogView({className, ...props}) {
    const {title} = useParams();
    const navigation = useNavigate();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);


    function getBlog() {
        setLoading(true)
        axiosInstance.get(URLS.getBlogs, {
            params: {
                title: title
            }
        }).then(response => {
            setBlog(response?.data?.data)
        }).catch(err => {
            navigation("/blogs/404")
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        const blogDiv = document.getElementById("top-blog");
        window.scrollTo(0, blogDiv.offsetTop)


        getBlog()
    }, [title])

    return (
        <div id={"top-blog"}
             className={` ${className} px-4 py-4 gap-[32px] lg:px-[112px] flex flex-col-reverse lg:flex-row`}>
            <div className={"w-full lg:w-[342px]"}>
                {blog?.content && (
                    <TOC content={addIdsToHeadings(blog?.content)}/>
                )}
                <div className={"my-2"}/>
                <RecentBlog
                    loading={loading}
                    title={blog?.title}
                />
            </div>
            {
                loading ? <BlogPostAnimation/> :
                    <div className={"w-full lg:flex-1  blog-section flex flex-col gap-[32px]"}>

                        <p className={"text-sm font-semibold text-secondary-900"}>
                            {blog?.updated_at}
                        </p>
                        <p className={"text-3xl font-bold"}>
                            {blog?.title}
                        </p>
                        <img
                            src={getUri(blog?.thumbnail?.file)}
                            alt={"blog"}
                            className={"w-full m-auto h-[300px] object-cover rounded-md"}
                        />

                        <p className={"text-base"}>
                            {blog?.meta_description}
                        </p>

                        <ReactQuill
                            value={addIdsToHeadings(blog?.content)}

                            readOnly={true}
                            theme={"bubble"}
                        />

                    </div>
            }
        </div>

    )
}